import { useToast, sizing } from '@chillibean/component-library';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { ProtocolForm, ProtocolHeader } from '../../components/container';
import { createProtocol } from '../../redux/actions';

export function ProtocolsNewPage() {
  // HOOKS
  // Store
  const dispatch = useDispatch();
  const { account, authenticityToken } = useSelector((state) => state.internalReducer.internal);
  // Router
  const history = useHistory();
  // Custom
  const { showErrorToast, showSuccessToast } = useToast();

  const handleCreateSuccess = (data) => {
    showSuccessToast('Trial Configuration created successfully');
    history.push(`/administration/study_protocols/${data.id}`);
  };

  const handleCreate = (data) => {
    dispatch(
      createProtocol({
        accountId: account?.id,
        authenticityToken: authenticityToken,
        onError: showErrorToast,
        onSuccess: handleCreateSuccess,
        protocolData: data,
      }),
    );
  };

  return (
    <Container>
      <ProtocolHeader header="New Trial Configuration" withButton={false} />
      <ProtocolForm onSave={handleCreate} values={{ issueDate: '', name: '' }} />
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizing.medium};

  padding: ${sizing.xllarge};
`;

export default ProtocolsNewPage;
